import { render, staticRenderFns } from "./service_form.vue?vue&type=template&id=2f149f44&scoped=true&"
import script from "./service_form.vue?vue&type=script&lang=js&"
export * from "./service_form.vue?vue&type=script&lang=js&"
import style0 from "./service_form.vue?vue&type=style&index=0&id=2f149f44&scoped=true&lang=scss&"
import style1 from "./service_form.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f149f44",
  null
  
)

export default component.exports